import React from 'react';
import style from "@/styles/pages/Dashboard/Dashboard.module.css";
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '@/store/dtm';
import { useEffect, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { useAuth } from '@/context/AuthContext';
import dayjs from 'dayjs';
import { createApiClient } from '@/lib/Requests';
import { TokenData } from '@/lib/DTMWebAPIClient.generated';

const ProtectedRoute: React.FC = () => {

  const timeout = sessionStorage.getItem("quickIdle") ? 35000 : 900000; //Set max idle time to 15 minutes (60,000 milliseconds * 15)
  const promptBeforeIdle = sessionStorage.getItem("quickIdle") ? 30000 : 60000;
  const [remaining, setRemaining] = useState<number>(timeout);
  const [openIdleModal, setOpenIdleModal] = useState<boolean>(false);
  const { login, logout } = useAuth();
  const credential = useSelector(
    (state: RootState) => state.credential.credential
  )
  const twoFactorAuth = useSelector(
    (state: RootState) => state.twoFactorAuth
  );
  const isAuthenticated = (credential.accessToken != "" && credential.refreshToken != "") || (twoFactorAuth.authTwoFa.sessionId != "");
  const client = createApiClient({ timeout: 60000, token: credential.accessToken });

  const onIdle = () => {
    setOpenIdleModal(false);
    logout();
  }

  const onAction = () => {
    checkTokenStatus();
  }

  const onActive = () => {
    setOpenIdleModal(false);
  }

  const onPrompt = () => {
    setOpenIdleModal(true);
  }

  const { getRemainingTime, activate } = useIdleTimer({
    onIdle,
    onActive,
    onPrompt,
    onAction,
    timeout,
    promptBeforeIdle,
    throttle: 500
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setRemaining(Math.ceil(getRemainingTime() / 1000))
    }, 500)

    return () => {
      clearInterval(interval)
    }
  })

  const handleStillHere = () => {
    checkTokenStatus();
    activate()
  }

  const checkTokenStatus = () => {
    if (credential.expiration && dayjs(credential.expiration).diff(dayjs(), 'minute') < 1) {
      client.apiAuthRefreshtoken(new TokenData({
        accessToken: credential.accessToken,
        refreshToken: credential.refreshToken
      })).then((result) => {
        login(result.accessToken != undefined ? result.accessToken : "", result.refreshToken != undefined ? result.refreshToken : "");
        console.log("Token refreshed!")
      });
    }
  }

  return isAuthenticated ?
    <div>
      <ConfirmDialog
        header={<h2 className="flex"><img src="assets/info.svg" style={{ width: 24, marginRight: 12 }} />Are you still here?</h2>}
        message={<p style={{ marginLeft: -14 }}>Logging out in {remaining} second{remaining <= 1 ? "" : "s"}</p>}
        defaultFocus='reject'
        acceptClassName={style.confirm}
        acceptLabel={"I'm still here"}
        rejectClassName={style.cancel}
        rejectLabel={"Logout"}
        accept={() => {
          handleStillHere();
        }}
        reject={() => {
          logout();
        }}
        draggable={false}
        closable={false}
        visible={openIdleModal} />
      <Outlet />
    </div>
    :
    <Navigate to="/login" />;
};

export default ProtectedRoute;